(function () {

    window.oneadvanced = window.oneadvanced || {};
    window.oneadvanced.responsivetabscarouselblock = window.oneadvanced.responsivetabscarouselblock || {};
    window.oneadvanced.responsivetabscarouselblock.init = function () {
        //console.log("initialising responsivetabscarouselblock...");
        var responsiveTabsCarousels = document.querySelectorAll('[data-tc-block-id]');
        if (responsiveTabsCarousels.length) {
            for (var rtc = 0; rtc < responsiveTabsCarousels.length; rtc++) {
                rtcHandler(responsiveTabsCarousels[rtc].getAttribute('data-tc-block-id'));
            }
        }
        function rtcHandler(blockId) {
            'use strict';
            var $tc_content = $('#tabs_carousel_content_' + blockId);
            var $tc_titles = $('#tabs_carousel_titles_' + blockId);
            var $tabs_titles_containers = $('.tabs-titles-container');
            var $tabId = $('#block' + blockId);

            // init variables to keep track of if Foundation or Slick have already been initialised
            var $tc_carousel_init = false;
            var $tc_tabs_init = false;

            $(window).on('changed.zf.mediaquery load', function (event, newSize, oldSize) {
                if (!newSize) {
                    newSize = Foundation.MediaQuery.current;
                }

                // ResponsiveTabsCarouselBlock switch from tabs in 'medium' and up to a carousel in 'small'
                // here we check Foundation's media query and if small run the code for the carousel
                // else we run the tabs
                if (newSize == "small") {

                    // Both Foundation and Slick have intermittent issues which follow resizing
                    // so we check if they've already been initialised and reset them back to their
                    // default HTML before proceeding
                    if ($tc_tabs_init) {
                        $tc_titles.foundation('_destroy');

                        $tc_tabs_init = false;
                    }
                    if ($tc_carousel_init) {
                        $tc_content.slick('unslick');
                        $tc_titles.slick('unslick');
                        $tabs_titles_containers.data('in-slick', false);
                    }

                    // Initialised Slick Carousel
                    $tc_content.slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        fade: true,
                        asNavFor: $tc_titles,
                        mobileFirst: true,
                        adaptiveHeight: true
                    });

                    $tc_titles.slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        asNavFor: $tc_content,
                        dots: false,
                        centerMode: true,
                        focusOnSelect: true,
                        respondTo: 'slider',
                        mobileFirst: true,
                        variableWidth: true
                    });

                    // update data attribute which CSS will use to apply the arrows
                    $tabs_titles_containers.data('in-slick', true);

                    // Set initialise flag
                    $tc_carousel_init = true;
                } else {
                    // We're not in 'small' any more, so we want tabs please

                    // Same check here to see if we've initilised and reset if so
                    if ($tc_tabs_init) {
                        $tc_titles.foundation('_destroy');
                    }
                    if ($tc_carousel_init) {
                        $tc_content.slick('unslick');
                        $tc_titles.slick('unslick');
                        $tabs_titles_containers.data('in-slick', false);

                        $tc_carousel_init = false;
                    }

                    //listen for the tabs initialized event and if it does initializes then remove the fallback class no-tabsjs
                    $tabId.on('init.zf.tabs', function () {
                        //console.log($(this));
                        //console.log("tabs are initialized, removed the fallback class");
                        $(this).children('div.inner').removeClass('no-tabsjs');
                    });

                    // set first tab content and title to is-active
                    $tc_titles.find('li:first-child').addClass('is-active');
                    $tc_content.find('li:first-child').addClass('is-active');

                    // Initialise tabs
                    var tabs = new Foundation.Tabs($tc_titles, {
                        deepLink: false,
                        updateHistory: false,
                        matchHeight: false,
                        deepLinkSmudge: false
                    });

                    // Set initialised flag
                    $tc_tabs_init = true;
                }

                // ensure that equalizer is run each time the browser is resized
                Foundation.reInit('equalizer');
            });
        }
    };
    window.oneadvanced.responsivetabscarouselblock.hasLoaded = true;

})();